import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import cx from 'classnames';
import React, { useRef } from 'react';
import useMount from 'react-use/lib/useMount';
import useUpdateEffect from 'react-use/lib/useUpdateEffect';
import { TimelineMax } from 'gsap/TweenMax';
import { kebabCase, toLower } from 'lodash-es';
import { config } from '../helpers/config';
import Close from './Close';

var Alert = function Alert(_ref) {
  var children = _ref.children,
      className = _ref.className,
      collapse = _ref.collapse,
      _onComplete = _ref.onComplete,
      _onReverseComplete = _ref.onReverseComplete,
      onReverseStart = _ref.onReverseStart,
      _onStart = _ref.onStart,
      close = _ref.close,
      title = _ref.title,
      type = _ref.type,
      opts = _objectWithoutPropertiesLoose(_ref, ["children", "className", "collapse", "onComplete", "onReverseComplete", "onReverseStart", "onStart", "close", "title", "type"]);

  var alertRef = useRef();

  var attachTimeline = function attachTimeline() {
    var $alert = alertRef.current;
    var forward = true;
    var lastTime = 0; // Attach GSAP

    $alert.timeline = new TimelineMax({
      paused: true,
      onStart: function onStart() {
        _onStart();

        $alert.setAttribute('aria-hidden', true);
      },
      onUpdate: function onUpdate() {
        var newTime = $alert.timeline.time();

        if (forward && newTime < lastTime || !forward && newTime > lastTime) {
          forward = !forward;

          if (!forward) {
            onReverseStart();
            $alert.classList.remove(config.classes.hidden);
            $alert.classList.remove(config.classes.uHidden);
            $alert.setAttribute('aria-hidden', false);
          }
        }

        lastTime = newTime;
      },
      onComplete: function onComplete() {
        _onComplete();

        $alert.classList.add(config.classes.hidden);
      },
      onReverseComplete: function onReverseComplete() {
        _onReverseComplete();
      }
    });
    $alert.timeline.to($alert, 0.5, {
      css: {
        marginTop: -$alert.offsetHeight,
        transformOrigin: 'center center',
        y: '50%',
        opacity: 0
      },
      ease: config.easing
    });

    if (collapse) {
      $alert.timeline.progress(1);
    }
  };

  var collapseAlert = function collapseAlert() {
    var $alert = alertRef.current;
    if ($alert && $alert.timeline) $alert.timeline.play();
  };

  var openAlert = function openAlert() {
    var $alert = alertRef.current;
    if ($alert && $alert.timeline) $alert.timeline.reverse();
  };

  useMount(function () {
    attachTimeline();
  });
  useUpdateEffect(function () {
    if (collapse) {
      collapseAlert();
    } else {
      openAlert();
    }
  }, [collapse]);
  var classes = cx('alert', {
    'alert--primary': type === 'primary',
    'alert--warning': type === 'warning',
    'alert--danger': type === 'danger'
  }, className);
  return React.createElement("div", Object.assign({
    className: classes,
    role: "alert",
    ref: alertRef
  }, opts), React.createElement("div", {
    className: "alert-content"
  }, title && React.createElement("h4", {
    id: kebabCase(toLower(title)),
    className: "alert-title"
  }, title), children), close && React.createElement("div", {
    className: "alert-right"
  }, React.createElement(Close, {
    className: "alert-close",
    onClick: collapseAlert
  })));
};

Alert.defaultProps = {
  onComplete: function onComplete() {},
  onReverseComplete: function onReverseComplete() {},
  onReverseStart: function onReverseStart() {},
  onStart: function onStart() {},
  collapse: false
};
export default Alert;